import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccessDenied from "../../../feature-module/pages/error/access-denied";
import { AppDispatch } from "../../data/redux/store";
import { usePermissions } from "../context/PermissionsUserContext";

/**
 * withPermission est un HOC (Higher-Order Component) qui :
 * - prend en paramètre le composant à protéger (WrappedComponent)
 * - et les permissions minimales requisent (requiredPermissions)
 * - l'action à effectuer s'il n'as pas les permissions
 */

type actions = "masquer" | "accès-refuser" | "rediriger";

const withPermission = (
  WrappedComponent: any,
  requiredPermissions: string[],
  action: actions,
) =>
  function AuthorizationWrapper(props: any) {
    const dispatch = useDispatch<AppDispatch>();
    const isAuth = useSelector((state: any) => state.auth.isAuthenticated);
    const isSuperAdmin = useSelector(
      (state: any) => state.auth.user?.isSuperAdmin,
    );
    const { permissions } = usePermissions();

    // Supposons que dans le store Redux on ait un slice "auth"
    // avec user.permissions qui est un tableau de chaînes de caractères.
    const isUserLoaded: boolean = useSelector(
      (state: any) => state.auth.isUserLoaded,
    );

    // s'il est connecter et que ces informations n'ont pas été charger
    useEffect(() => {
      // if (isAuth && !isUserLoaded) dispatch(loadUserData(isAuth));
    }, [dispatch, isAuth, isUserLoaded]);

    const hasPermission =
      requiredPermissions.some((perm: string) => permissions.includes(perm)) ||
      isSuperAdmin; // Donner le droit si la personne détient la permission nécessaire ou si c'est le superAdmin

    // si l'utilisateur n'est pas connecter
    if (!isAuth) return null;

    // verifie si l'utilisateur à les permissions requisent
    if (!hasPermission) {
      // on peut faire plusieurs chose comme:
      // 1) Retourner null pour ne rien afficher
      // 2) Afficher un composant "Accès refusé"
      // 3) Rediriger vers une page login ou d'erreur
      switch (action) {
        case "masquer":
          return null;
        case "accès-refuser":
          return <AccessDenied />;
        default:
          return null;
      }
    }

    return <WrappedComponent {...props} />;
  };

export default withPermission;
